var ksummernote = {
    init: function (id, netInstance, lang, height) {
        var fLang = lang.toLowerCase() == "en" ? "en-US" : "es-ES";
        console.log('creating sn instance: ' + id);
        $('#' + id).summernote({
            lang: fLang,
            tabsize: 2,
            height: height,
            toolbar: [
                ['style', ['style']],
                ['font', ['bold', 'underline', 'clear']],
                ['color', ['color']],
                ['para', ['ul', 'ol', 'paragraph']],
                ['table', ['table']],
                ['insert', ['link', 'picture', 'video']],
                ['view', ['codeview', 'help']]
            ],
            callbacks: {
                onChange: function (contents, $editable) {
                    netInstance.invokeMethodAsync('ChangeValue', contents);
                }
            }
        });
    }
};

